<div class="row">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-3"></div>
      <div class="col-sm-6">
        <form [formGroup]="trainingForm">
          <input type="hidden" formControlName="id" />
          <div class="form-group">
            <label class="lbl">{{partnerPak.languageLbl}}</label>
            <kendo-dropdownlist class="kendoInput" name="languageCode"
                                formControlName="languageCode"
                                [data]="getLanguages"
                                [textField]="'languageCode'"
                                [valueField]="'languageCode'"
                                [ngModel]="{languageCode:selectedLanguage}" (selectionChange)="lanaguageChange($event)" [ngClass]="{'borderRed':partnerPak.isLanguageCodeEmpty && partnerPak.isSubmitted}" (blur)="validatePartnerPakForm()">
            </kendo-dropdownlist>
          </div>
          <div class="form-group">
            <!--[for]="terms"-->
            <kendo-label class="k-radio-label"
                         text="Input Method &nbsp; &nbsp;   "></kendo-label>
            <input type="radio"
                   name="partnerPakInputMethod"
                   value="TextEditor"
                   #textEditor [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="partnerPakInputMethod"
                   kendoRadioButton />
            <label class="k-label" [for]="textEditor">Text Editor &nbsp;</label>

            <input type="radio"
                   name="partnerPakInputMethod"
                   value="FileUpload"
                   #fileUpload [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="partnerPakInputMethod"
                   kendoRadioButton />
            <label class="k-label" [for]="fileUpload">File Upload</label>
          </div>
          <div class="form-group" [hidden]="partnerPakInputMethod==='FileUpload'">
            <label class="lbl">{{partnerPak.descriptionLbl}}</label>
            <!--<textarea kendoTextArea class="kendoInput textArea-height"
          formControlName="description" [disabled]="!enableText" [ngClass]="{'borderRed':partnerPak.isDescriptionEmpty && partnerPak.isSubmitted}"
              (blur)="validatePartnerPakForm()"></textarea>-->
            <kendo-editor class="kendoInput" formControlName="description"
                          [ngClass]="{'borderRed':partnerPak.isDescriptionEmpty && partnerPak.isSubmitted}" (blur)="validatePartnerPakForm()"></kendo-editor>
          </div>
          <div class="form-group" *ngIf="partnerPakInputMethod==='FileUpload'">
            <div class="kendoInput">
              <app-upload [multiple]="false" (fileSelect)="partnerPakSelected($event)"
                          [uploadFolderPath]="'TempDocs\\PreInstallation'"
                          [ngClass]="{'borderRed':partnerPak.isEmptyPartnerPakUrlPath && partnerPak.isSubmitted}"
                          (uploadSuccess)="partnerPakUploadSuccess($event)"
                          [fileRestrictions]="fileRestrictions"></app-upload>
            </div>
            <!--<label class="lblCls">
              {{partnerPakUrlPath}}
            </label>-->

          </div>
          <div class="form-group" *ngIf="partnerPakInputMethod==='FileUpload'">
            <div id="pdfIframediv" class="row myIframe" *ngIf="partnerPakUrl">
              <iframe class="PdfReport"
                      [src]="partnerPakUrl"
                      type="application/pdf"></iframe>
            </div>
          </div>
        </form>
        <br />
        <div class="align-center">
          <div class="btn-group" role="group">
            <button kendoButton class=" m-3 btn k-button"
                    (click)="resetForm()">
              Cancel
            </button> &nbsp;&nbsp;
            <button kendoButton class=" m-3 btn btn-success"
                    (click)="savePartnerPakTrainingDescription()">
              Save<!--<kendo-loader style="color:blue"></kendo-loader>-->
            </button>
            <!--*ngIf="saveInProcess"-->
          </div>
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>

  </div>
</div>

